<template>
  <v-card>
    <v-card-title class="headline py-2">
      {{formTitle}}
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('close-dialog')" class="mx-0"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-divider></v-divider>
    
    <v-card-text>
      <v-form @submit="submit" onSubmit="return false;">
        <v-card flat>
          <v-text-field
                  v-model="type.name"
                  label="Название"
                  :error-messages="veeErrors.collect('Название')"
                  v-validate="'required'"
                  data-vv-name="Название"
                  required
          ></v-text-field>

          <v-textarea
                  v-model="type.description"
                  label="Описание"
                  rows="3"
          ></v-textarea>

          <div class="mb-2">
            <p class="pa-0 mt-1" style="float: left">Цвет: </p>
            <div :style="{display:'inline-block', marginLeft:'10px', cursor: 'pointer' , width:'60px', height: '30px', background: colors.hex}" @click="showColors=!showColors"></div>
          </div>
          <swatches-picker v-show="showColors" v-model="colors" @input="showColors=false"></swatches-picker>
        </v-card>
      </v-form>
    </v-card-text>
  
    <v-divider></v-divider>
    <v-card-actions class="pa-3">
      <v-btn color="success" @click.prevent="submit" :disabled="status.btnDisabled" type="submit">Сохранить</v-btn>
      <span :class="status.className" class="ml-2">{{status.text}}</span>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { Swatches } from 'vue-color'

  export default {
    name: 'TypeForm',

    components:{
      'swatches-picker': Swatches
    },

    props: {
      data:{
        type: Object,
        required: true,
      },
      editMode:{
        type: Boolean,
        required: false,
        default: false,
      }
    },

    computed:{
      formTitle(){
        return (this.editMode) ? 'Редактировать тип' : 'Добавить новый тип'
      }
    },

    data(){
      return {
        showColors:false,
        colors: {
          hex: '#000000',
          hsl: {
            h: 0,
            s: 0,
            l: 0,
            a: 1
          },
          hsv: {
            h: 0,
            s: 0,
            v: 0,
            a: 1
          },
          rgba: {
            r: 0,
            g: 0,
            b: 0,
            a: 1
          },
          a: 1
        },
        status:{
          btnDisabled: false,
          text: '',
          className:'green--text darken-1'
        },
        type: {}
      }
    },

    mounted(){
      this.type = {
        id: this.data.id,
        name: this.data.name,
        description: this.data.description,
        color: this.data.iconcolor
      }
      this.colors.hex = this.type.color
    },

    methods: {
      submit(){
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.status={ btnDisabled: true, text: 'Сохранение', className:'grey--text lighten-1' }

            if( this.editMode === true ){
              this.$store.dispatch('orgstructure/updateType', this.type).then( response => {
                this.status={ btnDisabled: false, text: 'Сохранено', className:'green--text darken-1' }
                this.$emit('close-dialog')
              }).catch( err => {
                this.status={ btnDisabled: false, text: 'Ошибка', className:'red--text darken-1' }
              })
            } else {
              this.$store.dispatch('orgstructure/createType', this.type).then( response => {
                this.status={ btnDisabled: false, text: 'Сохранено', className:'green--text darken-1' }
                this.$emit('close-dialog')
              }).catch( err => {
                this.status={ btnDisabled: false, text: 'Ошибка', className:'red--text darken-1'}
              })
            }
            return
          }
        })
        return false
      },
    },

    watch:{
      colors(){
        this.type.color = this.colors.hex
      }
    }
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/apps/org/components/Types/TypeForm.vue